import { destroy, types, Instance } from 'mobx-state-tree';
import { Follow, IFollow } from './Follow';
import { callAgroApi } from '@services/agroapi';
export const FollowStore = types.model('FollowStore', {
  completed: types.model({
    follows: types.map(Follow)
  }),
  pending: types.model({
    follows: types.map(Follow),
    followers: types.map(Follow)
  })
}).views(self => ({
  get completedFollows() {
    return Array.from(self.completed.follows.values());
  }
})).actions(self => ({
  destroyFollow(follow: IFollow) {
    destroy(follow);
  },
  acceptPendingInvite(followId: string) {
    return callAgroApi<{
      message: string;
    }>(`/follows/${followId}/accept`, 'POST');
  },
  rejectPendingInvite(followId: string) {
    return callAgroApi<{
      message: string;
    }>(`/follows/${followId}/reject`, 'DELETE');
  }
}));
export type IFollowStore = Instance<typeof FollowStore>;